import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import axios from 'axios';
import dayjs from 'dayjs';
import {
    message,
    Button,
    Modal,
    Input,
    Radio,
    Select,
    Popover,
    Checkbox,
    Timeline,
    Tag,
    Popconfirm,
    Dropdown,
    Menu
} from 'antd';
import {
    CarOrCardPic,
    ProcessedRecords
} from '../../components';
import MaterialExpress from '../../containers/ReportTabs/MaterialExpress/index.js';
import { ReportCreate, ReportCreateNew, LossMessage, EleControlPane } from '../../containers/index'
import TaskListModal from '../../../../client/components/Header/TaskListModal.js';
import { agentActions } from '../../../actions';
import { report, lossAssDashboard, reportPreviewActions } from '../../actions';
import { safetyMechanismAction } from '../../../actions';
import RiskSystem from '../../../components/RiskSystem/index';
import WithRemark from '../../../components/HOC/remark';
import RiskFlag from '../../../components/RiskFlag';
import RecommendCheckedBtn from '../../containers/ReportDetail/RecommendCheckedBtn';
import RecommendWithdraw from '../../containers/ReportDetail/RecommendWithdraw';
import { boundActions } from '../../../store';
import t from '../../../localization';
import { default as chinese_simplified } from '../../../localization/zh-cn';
import config from '../../../config';
import { getLabel } from '../../../utils/index';
import { qhElemeReportStatus } from '../../../constants/enumByQHEleme';
import { getReportInfo, setRelateComplaint, reopenReport } from '../../../service/report';
import './style.scss';

const { defLossTaskStateNames = {}, defLossTaskSubStateNames = {} } = chinese_simplified;


const { Option } = Select;
const { TextArea } = Input;
const adjustStatusMap = {
    claiming: '审核中',
    claimed: '审核完成'
};
const statusMap = {
    0: '未推送',
    1: '已推送',
    2: '已结案'
};

const auditStatusMap = {
    ONLINE_INFO_TO_BE_SUBMITTED_TO_INSURE_COMPANY: '资料待提交',
    ONLINE_INFO_CHECKING: '电子资料审核中',
    ONLINE_INFO_TO_BE_ADDED: '待补充电子资料',
    PAPER_INFO_TO_BE_ADDED: '待补充纸质资料',
    PAPER_INFO_CHECKING: '纸质资料审核中',
    REJECT: '拒赔',
    CASE_CLOSED_WITH_NO_PAY: '0结',
    ACCOUNT_COMPLETE: '赔付成功',
    CANCEL: '撤案',
    CANCEL_BY_INSURE_COMPANY: '注销'
};
/**
 * 医疗理算员
 */
function isAdjustAgentRole(agent) {
    const { agentRole = {} } = agent;
    return !!agentRole.isAdjust;
}
/**
 * 查勘理算员
 */
function isSurveyAgentRole(agent) {
    const { agentRole = {} } = agent;
    return !!agentRole.isSurvey;
}

// 案件状态必须满足其一：状态1，已定损；状态2，已结案且重新打款；
function isBounceByReport(report) {
    return (
        report.state === 'checked' ||
        (report.state === 'finished' && report.subState === 'reRemitt')
    );
}
class ReportDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            flowId: props.match.params.flowId,
            readStatus: undefined,
            complaintResult: {
                records: []
            },
            aboutAgent: {},
            isShowTaskListModal: false,
            allValues: {},

            dataSource: [],
            value: 1,

            adjustStatus: 'create', //create 未创建 finish创建完成
            adjust: {},
            // 协作类型
            taskType: 'create',
            // 当前选择tab
            showformOrVideoOrPhoto: 'formReport',
            majorCaseTypes: [],
            assigned: '',
            // 重开案件
            reopenLoading: false,
            reopenVisible: false
        };
    }

    componentDidMount() {
        const { currentAgent } = this.props;
        this.init();
        this.getMajorCaseTypes(currentAgent.tenant.code);
    }
    static getDerivedStateFromProps(props, state) {
        const flowId = props.match.params.flowId;
        if (flowId && (flowId !== state.flowId)) {
            return {
                flowId
            }
        }
        return null;
    }
    componentDidUpdate(prevProps) {
        const flowId = this.props.match.params.flowId,
            prevFlowId = prevProps.match.params.flowId;
        if (flowId !== prevFlowId) {
            // // 清空标签数据
            this.init();
        }
    }
    componentWillUnmount() {
        window.removeEventListener('message', this.receiveMessage, false);
    }
    onChange = (e) => {
        this.setState({
            value: e.target.value
        });
    };


    //
    handleOkComplain = (e) => {
        if (!this.state.valueRadioComplain || this.state.valueCheckboxComplain.length === 0) {
            message.info('请检查必填项');
            return;
        }
        axios({
            method: 'post',
            url: '/api/lossAss/complaint',
            data: {
                flowId: this.state.flowId,
                agentId: this.props.currentAgent._id,
                types: this.state.valueCheckboxComplain.join(),
                level: this.state.valueRadioComplain,
                content: this.state.textAreaValue
            }
        })
            .then((res) => {
                if (res.data.errCode == 0) {
                    message.success('操作成功');
                    this.getLossAssComplaint();
                    this.setState({
                        visibleComplain: false,
                        valueRadioComplain: undefined,
                        valueCheckboxComplain: [],
                        textAreaValue: ''
                    });
                } else {
                    message.error(res.data.errInfo);
                }
            })
            .catch((err) => {
                message.error(err.message || '请求/api/lossAss/complaint失败');
            });
    };

    handleCancelComplain = (e) => {
        this.setState({
            visibleComplain: false,
            valueRadioComplain: undefined,
            valueCheckboxComplain: [],
            textAreaValue: ''
        });
    };
    onChangeTextAreaValue = (e) => {
        this.setState({
            textAreaValue: e.target.value
        });
    };
    onChangeRadioComplain = (e) => {
        this.setState({
            valueRadioComplain: e.target.value
        });
    };
    onChangeCheckboxComplain = (checkedValues) => {
        this.setState({
            valueCheckboxComplain: checkedValues
        });
    };
    showComplainModal = () => {
        this.setState({
            visibleComplain: true
        });
    };
    getLossAssComplaint = () => {
        this.setState({
            valueRadioComplain: undefined,

            complaintResult: {
                records: []
            }
        });
        setTimeout(() => {
            const { flowId } = this.state;
            if (!flowId) {
                return;
            }
            axios({
                method: 'get',
                url: '/api/lossAss/complaint',
                params: {
                    flowId
                }
            })
                .then((res) => {
                    if (res.data.errCode == 0) {
                        this.setState({
                            valueRadioComplain: res.data.result.curLevel,
                            complaintResult: res.data.result
                        });
                    } else {
                        message.error(res.data.errInfo);
                    }
                })
                .catch((err) => {
                    message.error(err.message || '请求/api/lossAss/complaint失败');
                });
        }, 1000);
    };
    handleShowTaskListModal = (type, assigned = 'me') => {
        // this.TaskListModal.getCoopTaskList()
        this.setState({
            taskType: type || 'create',
            isShowTaskListModal: true,
            assigned
        });
    };

    showModal = () => {
        // 调用子组件的方法

        this.child.showModal();
    };
    hideTaskListModal = () => {
        this.setState({
            isShowTaskListModal: false
        });
        // this.TaskListModal.showModal()
    };
    getDetail = () => {
        const { actions } = this.props;
        getReportInfo(this.state.flowId, {
            from: 'agent'
        }).then(async (res) => {
            const report = res.result;
            if (report) {
                if (report.ownCarLoss) {
                    actions.selectedCar(report.ownCarLoss._id);
                } else {
                    actions.selectedCar(report._id);
                }
            }
            // await actions.reportPageOrForm('reportForm');
            await actions.selectedReport(report);
        });
    }
    init() {
        this.getDetail();
        this.getCoopTaskAboutAgent();
        this.getLossAssComplaint();
        this.getAdjustReportInfo();
        window.addEventListener('message', this.receiveMessage, false);
    }

    //获取工单的理算信息
    getAdjustReportInfo = () => {
        const { currentAgent } = this.props;
        const { flowId } = this.state;
        if (!flowId) {
            return;
        }
        axios({
            method: 'GET',
            url: `/api/adjustReport/v2/${flowId}`,
            params: {
                flowId,
                agentId: currentAgent._id
            }
        })
            .then((res) => {
                if (res.data.errCode == 0) {
                    this.setState({
                        adjustStatus: 'finish',
                        adjust: res.data.result
                    });
                } else {
                    this.setState({
                        adjustStatus: 'create'
                    });
                    // message.error(res.data.errInfo)
                }
            })
            .catch((err) => {
                message.error(err.message);
            });
    };

    viewAdjustDetails = () => {
        const { currentAgent } = this.props;
        const { flowId } = this.state;

        if (!flowId) {
            return;
        }
        // 获取受理号

        axios({
            method: 'GET',
            url: `/api/adjustReport/v2/${flowId}/fetch`,
            headers: {
                flowId,
                agentId: currentAgent._id
            },
            data: {
                flowId,
                agentId: currentAgent._id
            }
        })
            .then((res) => {
                if (res.data.errCode == 0) {
                    const adjustFlowId = res.data.result.adjustFlowId;

                    axios({
                        method: 'POST',
                        url: `/api/adjustReport/auth`,
                        data: {
                            loginName: localStorage.getItem('preSaveName'),
                            password: localStorage.getItem('preSavePwd')
                        }
                    })
                        .then((res) => {
                            if (res.data.errCode == 0) {
                                const adjustAccessToken = res.data.result.adjustAccessToken;

                                const timeStamp = new Date().getTime();
                                if (adjustFlowId) {
                                    const src = `${config.newMedicalcheckDomain
                                        }/medicalcaredetails?flowId=${adjustFlowId}&timeStamp=${timeStamp}&companyId=${currentAgent.tenant && currentAgent.tenant._id
                                        }&orgId=${currentAgent.orgAccount && currentAgent.orgAccount._id
                                        }&agentId=${currentAgent._id}&accountAccess=${currentAgent.agentRole && currentAgent.agentRole.level
                                        }&activeKey=${''}&isCreateAdjust=${currentAgent.isCreateAdjust
                                        }&imgBasePath=${currentAgent.tenant && currentAgent.tenant.imgBasePath
                                        }&bucketName=${currentAgent.tenant && currentAgent.tenant.imgBasePath
                                        }&server=${config.server}&isFastOcr=${currentAgent.orgAccount && currentAgent.orgAccount.isFastOcr
                                        }&isAccurateOcr=${currentAgent.orgAccount &&
                                        currentAgent.orgAccount.isAccurateOcr
                                        }&isCrowdsourceOcr=${currentAgent.orgAccount &&
                                        currentAgent.orgAccount.isCrowdsourceOcr
                                        }&token=${adjustAccessToken}`;

                                    window.open(src);
                                }
                            } else {
                                message.error(res.data.errInfo);
                            }
                        })
                        .catch((err) => {
                            message.error(err.message);
                        });
                } else {
                    message.error(res.data.errInfo);
                }
            })
            .catch((err) => {
                message.error(err.message);
            });
        //
    };

    handleRefresh = () => {
        const { currentAgent } = this.props;
        const { flowId } = this.state;
        if (!flowId) {
            return;
        }
        axios({
            method: 'GET',
            url: `/api/adjustReport/v2/${flowId}/fetch`,
            headers: {
                flowId,
                agentId: currentAgent._id
            },
            data: {
                flowId,
                agentId: currentAgent._id
            }
        })
            .then((res) => {
                if (res.data.errCode == 0) {
                    message.success('操作成功');
                    this.setState({
                        adjustStatus: 'finish',
                        adjust: res.data.result
                    });
                    // 重新获取工单详情

                    res.data.result.status === 'claimed' &&
                        this.props.actions.getCurrentReport(flowId, currentAgent._id);
                } else {
                    message.error(res.data.errInfo);
                }
            })
            .catch((err) => {
                message.error(err.message);
            });
    };

    uploadAgentPic = () => {
        const { currentAgent } = this.props;
        const { flowId } = this.state;
        if (!flowId) {
            return;
        }
        axios({
            method: 'POST',
            url: `/api/adjustReport/v2/${flowId}/uploadPics`,
            headers: {
                flowId,
                agentId: currentAgent._id
            },
            data: {
                flowId,
                agentId: currentAgent._id
            }
        })
            .then((res) => {
                if (res.data.errCode == 0) {
                    message.success('操作成功');
                } else {
                    message.error(res.data.errInfo);
                }
            })
            .catch((err) => {
                message.error(err.message);
            });
    };

    getCoopTaskAboutAgent = () => {
        setTimeout(() => {
            const { currentAgent } = this.props;
            const { flowId } = this.state;

            if (!flowId) {
                return;
            }
            axios({
                method: 'get',
                url: `/api/lossAss/coopTask/aboutReport`,
                params: {
                    flowId,
                    agentId: currentAgent._id
                }
            })
                .then((res) => {
                    if (res.data.errCode === 0) {
                        this.setState({
                            aboutAgent: res.data.result
                        });
                    } else {
                        message.error(res.data.errInfo);
                    }
                })
                .catch((err) => {
                    message.error(err.message || '请求/api/lossAss/coopTask/aboutAgent失败');
                });
        }, 1000);
    };

    handleBack() {
        const { location, history } = this.props;
        history.push({
            pathname: '/customerCenter/ReportPage',
            query: location.query || {}
        });
    }

    switchChange(tabKey) {
        const { actions, onSelectedReport } = this.props;

        if (onSelectedReport.ownCarLoss) {
            actions.selectedCar(onSelectedReport.ownCarLoss._id);
        }
        this.setState({
            showformOrVideoOrPhoto: tabKey
        });
    }

    getMtime = (c, a) => {
        let v = '';
        if (a) v = a;
        if (!v && c) v = moment(c).format('YYYY-MM-DD  HH:mm:ss');
        return v;
    };
    showRemarksModal = () => {
        boundActions.getChangeRemarkAction({
            status: 'unfold'
        })
    };

    getReadStatus = () => {
        const BASE_URL = '';
        const { flowId } = this.state;
        axios({
            method: 'get',
            url: `${BASE_URL}/api/lossAss/report/eleme/riskContr/flag/read`,
            params: {
                flowId
            }
        })
            .then((res) => {
                if (res.data.errCode == 0) {
                    this.setState({
                        readStatus: res.data.result.readStatus
                    });
                } else {
                    message.error(res.data.errInfo);
                }
            })
            .catch((err) => {
                message.error(
                    err.message || '请求/api/lossAss/report/eleme/riskContr/flag/read失败'
                );
            });
    };

    // 获取列表数据传递给子组件
    getListData = () => {
        this.setState({
            loading: true
        });
        // flowId={onSelectedReport.flowId}
        // currentAgent={this.props.currentAgent}
        axios({
            method: 'get',
            url: `${BASE_URL}/api/lossAss/report/eleme/riskContr/flag`,
            params: {
                flowId: this.state.flowId,
                agentId: this.props.currentAgent._id
            }
        })
            .then((res) => {
                if (res.data.errCode == 0) {
                    this.setState({
                        dataSource: res.data.result
                    });
                    this.handleRead();
                } else {
                    message.error(res.data.errInfo);
                }
                this.setState({
                    loading: false
                });
            })
            .catch((err) => {
                this.setState({
                    loading: false
                });
                message.error(err.message || '请求/api/lossAss/report/eleme/riskContr/flag失败');
            });
    };
    //
    receiveMessage = async (event) => {
        // window.removeEventListener("message", this.receiveMessage, false);
        const { actions } = this.props;
        const data = event.data;
        if (data.eventName === 'refreshReport') {
            // 重新获取工单详情
            let report = await actions.getCurrentReport(this.state.flowId);

            report = report.payload;
            if (report) {
                if (report.ownCarLoss) {
                    actions.selectedCar(report.ownCarLoss._id);
                } else {
                    actions.selectedCar(report._id);
                }
            }
            actions.selectedReport(report);

            window.removeEventListener('message', this.receiveMessage, false);
            setTimeout(() => {
                window.addEventListener('message', this.receiveMessage, false);
            }, 1000);
        }
    };

    getReport = async () => {
        const { actions } = this.props;
        let report = await actions.getCurrentReport(this.state.flowId);

        report = report.payload;
        if (report) {
            if (report.ownCarLoss) {
                actions.selectedCar(report.ownCarLoss._id);
            } else {
                actions.selectedCar(report._id);
            }
        }
        actions.selectedReport(report);
    }

    getMajorCaseTypes = (tenantCode = '') => {
        // 获取指派对象
        axios({
            method: 'get',
            url: '/api/lossAss/report/majorCaseTypes?tenantCode=' + tenantCode,
            params: {}
        })
            .then((res) => {
                if (res.data.errCode === 0) {
                    this.setState({
                        majorCaseTypes: res.data.result
                    });
                } else {
                    message.error(res.data.errInfo);
                }
            })
            .catch((err) => {
                message.error(
                    err.message || '请求/api/lossAss/report/majorCaseTypes?tenantCode=失败'
                );
            });
    };
    // 拒赔、撤案，重开案件
    handleReopen = async () => {
        this.setState({
            reopenLoading: true
        })
        try {
            const { orgAccount, tenant = {} } = this.props.onSelectedReport;
            const { flowId } = this.state;
            await reopenReport({
                flowId,
                orgAccount,
                tenant: tenant._id
            })
            message.success('案件已重开');
            this.getReport();
        } catch {}
        this.setState({
            reopenLoading: false,
            reopenVisible: false
        })
    }
    // 取消重开案件
    handleCancelReopen = () => {
        this.setState({
            reopenVisible: false,
            reopenLoading: false
        })
    }
    render() {
        const {
            currentAgent,
            actions,
            onSelectedReport,
            reportPreview,
            customer
        } = this.props,
            { tenant = {} } = currentAgent;
        const imgBasePath = currentAgent.tenant ? currentAgent.tenant.imgBasePath : '';
        const { taskType, showformOrVideoOrPhoto, flowId, reopenLoading, reopenVisible } = this.state;
        const riskSysmPermissions = currentAgent?.orgAccount?.riskSysmPermissions;
        // 坐席所在机构权限
        const orgPermissions = currentAgent?.orgAccount?.permissions || [];
        // 坐席权限
        const agentPermissions = currentAgent?.permission || [];

        // 是否为案件处理人本人
        const isReportAgent = onSelectedReport.agentId && (onSelectedReport.agentId?._id  === currentAgent?._id);
        // 是否为单证岗审核员（有单证审核权限，且有当前案件机构的邮寄权限）
        const isExpressAuditor = currentAgent?.permission?.includes('expressMaterial') && currentAgent?.expressOrgs?.includes(onSelectedReport.orgAccount);

        let currentPreviewReport = reportPreview.currentPreviewReport
        const info =
            this.state.adjustStatus === 'create' ? (
                <div>
                    <p>尚未创建医核工单</p>
                    {/* <Button
                    type='primary'
                    style={{ margin: '0px 0px 0px 60px' }}
                    onClick={this.handleCreate}

                >
                    点击创建
                </Button> */}
                </div>
            ) : (
                <div>
                    <p>
                        审核状态:{adjustStatusMap[this.state.adjust.status]}
                        {this.state.adjust.status === 'claiming' && (
                            <i
                                className="iconfont icon-sync"
                                onClick={this.handleRefresh}
                                style={{ marginLeft: 20 }}
                            />
                        )}
                    </p>
                    <p>
                        处理人:{this.state.adjust.username} {this.state.adjust.cellphone}
                    </p>

                    {this.state.adjust.status === 'claiming' && isSurveyAgentRole(currentAgent) && (
                        <Button
                            style={{ margin: '0px 0px 0px 60px' }}
                            onClick={this.uploadAgentPic}
                        >
                            更新照片
                        </Button>
                    )}
                    {(isAdjustAgentRole(currentAgent) ||
                        currentAgent.agentRole.level === '2' ||
                        currentAgent.agentRole.level === '3') && (
                            <Button
                                type="primary"
                                style={{ margin: '0px 0px 0px 20px' }}
                                onClick={this.viewAdjustDetails}
                            >
                                进入医核
                            </Button>
                        )}
                </div>
            );
        let options = [];

        if (currentAgent && tenant && tenant.complainTypes && tenant.complainTypes.length > 0) {
            options = tenant.complainTypes.filter((item) => !item.disable);
        }

        let subTitle;
        if (showformOrVideoOrPhoto == 'formReport') {
            subTitle = '工单';
        } else if (showformOrVideoOrPhoto == 'pictureCapture') {
            subTitle = '快速取证';
        } else if (showformOrVideoOrPhoto == 'processedRecords') {
            subTitle = '处理记录';
        } else if (showformOrVideoOrPhoto == 'OCRInfo') {
            subTitle = 'OCR 信息';
        } else if (showformOrVideoOrPhoto == 'lossMessage') {
            subTitle = '消息留言';
        } else if (showformOrVideoOrPhoto == 'ele') {
            subTitle = '饿了风控';
        } else if (showformOrVideoOrPhoto == 'risk-system') {
            subTitle = '风险预警';
        } else if (showformOrVideoOrPhoto == 'express-material') {
            subTitle = '邮寄材料';
        }

        const stateLabels = [];
        reportPreview.currentPreviewReport.outInsurancePeriod && stateLabels.push('跨保期');
        reportPreview.currentPreviewReport.multiReport && stateLabels.push('多次报案');
        const { defLossTask } = onSelectedReport || {};
        let defLossState = `${defLossTask ? defLossTaskStateNames[defLossTask.state] || '未知' : '暂无'
            }`;
        if (defLossTask && defLossTask.state === 'checking')
            defLossState = `${defLossState}/${defLossTaskSubStateNames[defLossTask.subState] || '未知'
                }`;
        
        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%',
                    position: 'relative'
                }}
            >
                <div className="video-nav-top">
                    <div
                        className="navigation"
                        style={{ justifyContent: 'space-between', alignItems: 'baseline' }}
                    >
                        <ol style={{ width: 250 }}>
                            <li>
                                <a role="button">
                                    <span>业务中心</span>
                                </a>
                            </li>
                            <li>
                                <a>
                                    <span>工单列表</span>
                                </a>
                            </li>
                            <li>
                                <a>
                                    <span>{subTitle}</span>
                                </a>
                            </li>
                        </ol>

                        <ul className="order-status">
                            {![13, 18, 20, 8].includes(currentAgent.tenant.code) ? (
                                <li>
                                    赔案号: {onSelectedReport.claimNo}
                                </li>
                            ) : null}

                            {currentAgent.tenant.code === 18 ? (
                                <li>
                                    保司状态: {statusMap[onSelectedReport.insureCompStatus]}
                                </li>
                            ) : null}

                            {tenant.code === 13 ? (
                                <li>
                                    申请号: {onSelectedReport.yuantong && onSelectedReport.yuantong.applyNo}
                                </li>
                            ) : null}
                            <li>
                                工单状态: {onSelectedReport ? t('reportStates::' + onSelectedReport.state) : ''}
                            </li>
                            <li>定损状态: {defLossState}</li>
                            {tenant.code === 8 ? (
                                <li>
                                    饿了么状态: {onSelectedReport.referer === 'ELEME' &&
                                        onSelectedReport.eleme &&
                                        auditStatusMap[onSelectedReport.eleme.auditStatus]}
                                </li>
                            ) : null}

                            {
                                [21].includes(currentAgent.tenant.code) ? <li>饿了么状态：{getLabel(qhElemeReportStatus, onSelectedReport?.qhEleme?.auditStatus)}</li> : null
                            }
                            <li>
                                回访: {(onSelectedReport.dealer && onSelectedReport.dealer.review) || '无'}
                            </li>
                            <li>
                                资料: {(onSelectedReport.dealer && onSelectedReport.dealer.agent) || '无'}
                            </li>
                            <li>
                                定损: {(onSelectedReport.dealer && onSelectedReport.dealer.loss) || '无'}
                            </li>
                            <li>
                                理赔: {(onSelectedReport.dealer && onSelectedReport.dealer.claim) || '无'}
                            </li>
                        </ul>
                    </div>
                    
                    <RiskFlag tenant={tenant} flowId={flowId} agentId={currentAgent?._id} actions={this.props.actions} />

                    <div className="customer-title" style={{ marginTop: 10, position: 'relative' }}>
                        <span
                            className={showformOrVideoOrPhoto == 'formReport' ? 'current-span1' : ''}
                            onClick={this.switchChange.bind(this, 'formReport')}
                        >
                            工单
                        </span>

                        <span
                            className={
                                showformOrVideoOrPhoto == 'pictureCapture' ? 'current-span1' : ''
                            }
                            onClick={this.switchChange.bind(this, 'pictureCapture')}
                        >
                            快速取证
                        </span>

                        {/* <span
                            className={showformOrVideoOrPhoto == 'lossMessage' ? 'current-span1' : ''}
                            onClick={this.switchChange.bind(this, 'lossMessage')}
                        >
                            消息留言
                        </span> */}

                        {
                            this.props.onSelectedReport?.referer === 'ELEME' ? <span
                                className={showformOrVideoOrPhoto == 'ele' ? 'current-span1' : ''}
                                onClick={this.switchChange.bind(this, 'ele')}
                            >
                                饿了风控{' '}
                                {this.state.readStatus === '0' && (
                                    <span
                                        style={{
                                            display: 'inline-block',
                                            width: 7,
                                            height: 7,
                                            borderRadius: '50%',
                                            background: 'red',
                                            position: 'relative',
                                            top: '-15px'
                                        }}
                                    ></span>
                                )}
                            </span> : null
                        }
                        {/* 公司管理员或者开启了显示权限才展示风险预警模块 */}
                        {
                            currentAgent?.agentRole?.level === '3' || Array.isArray(riskSysmPermissions) && riskSysmPermissions.includes('displayRiskWarning') ? <span className={showformOrVideoOrPhoto == 'risk-system' ? 'current-span1' : ''} onClick={this.switchChange.bind(this, 'risk-system')}>
                                <>
                                    <span>风险预警</span>
                                    {
                                        onSelectedReport.riskLevelId &&
                                        <span style={{ width: 6, height: 6, display: 'inline-block', background: 'red', borderRadius: '50%', position: 'relative', top: -10 }}></span>

                                    }

                                </>
                            </span> : null
                        }
                        <span
                            className={
                                showformOrVideoOrPhoto == 'processedRecords' ? 'current-span1' : ''
                            }
                            onClick={this.switchChange.bind(this, 'processedRecords')}
                        >
                            处理记录
                        </span>
                       {/* 
                        【邮寄材料tab】：
                         1.机构：有“材料邮寄”权限，显示tab；
                         2.操作人：案件处理人、单证审核岗（账号有“材料邮寄审核”权限，且有该案所属机构的审核权限），有操作权限
                            2.4.0版本去掉案件状态的判断
                            3.0.0版本去掉理赔金额大于租户-机构的 createEMAmountLimit 金额 或者 邮寄状态不为空
                        */}
                        {
                            orgPermissions.includes('expressMaterial') ? <span className={showformOrVideoOrPhoto == 'express-material' ? 'current-span1' : ''} onClick={this.switchChange.bind(this, 'express-material')}>
                                邮寄材料
                            </span> : null
                        }

                        <div className="order-btns">
                            <Button
                                size="small"
                                onClick={() => this.handleShowTaskListModal('create')}
                                type="primary"
                            >
                                新建协作
                            </Button>
                            {this.state.aboutAgent.todeal ? (
                                <Button
                                    onClick={() => this.handleShowTaskListModal('update')}
                                    size="small"
                                    type="danger"
                                >
                                    待我处理
                                    {this.state.aboutAgent.todeal > 0
                                        ? this.state.aboutAgent.todeal
                                        : ''}
                                </Button>
                            ) : null}
                            {this.state.aboutAgent.all ? (
                                <Button
                                    onClick={() => this.handleShowTaskListModal('update', 'all')}
                                    type="primary"
                                    size="small"
                                >
                                    全部协作
                                    {this.state.aboutAgent.all > 0 ? this.state.aboutAgent.all : ''}
                                </Button>
                            ) : null}
                        </div>
                    </div>
                </div>
                {
                    showformOrVideoOrPhoto == 'formReport' ? <div
                        className="report-list-bg"
                        style={{
                            position: 'relative',
                            height: '100%',
                            overflowY: 'auto',
                            flex: 1,
                            padding: '10px 10px 0',
                            background: '#fff'
                        }}
                    >
                        {
                            [21, 24, 25, 26, 27].includes(currentAgent.tenant.code) ? <ReportCreateNew
                                currentAgent={currentAgent}
                                agent={currentAgent}
                                flowId={flowId}
                                key="maifjlfcigbbck"
                                handleBackClick={this.handleBack.bind(this)}
                                actions={actions}
                                show={'detail'}
                                customer={customer}
                                imgBasePath={imgBasePath}
                                disabled={true} /> : <ReportCreate
                                key="maifjlfcigbbck"
                                currentAgent={currentAgent}
                                agent={currentAgent}
                                handleBackClick={this.handleBack.bind(this)}
                                initialValues={onSelectedReport}
                                actions={actions}
                                show={'detail'}
                                onSelectReport={onSelectedReport}
                                currentReport={onSelectedReport}
                                customer={customer}
                                imgBasePath={imgBasePath}
                                disabled={true}
                                getReportInfo={this.getDetail}
                            />
                        }
                    </div> : null
                }
                {
                    showformOrVideoOrPhoto === 'pictureCapture' ? <div
                        style={{
                            background: '#fff',
                            position: 'relative',
                            height: '100%',
                            overflowY: 'auto',
                            flex: 1,
                            padding: '10px 10px 45px',
                            position: 'relative'
                        }}
                    >
                        <CarOrCardPic
                            flowId={flowId}
                            reportPreview={reportPreview}
                            actions={actions}
                            currentReport={onSelectedReport}
                            currentAgent={currentAgent}
                            imgBasePath={imgBasePath}
                            source={2}
                        />
                    </div> : null
                }
                {
                    showformOrVideoOrPhoto === 'processedRecords' ? <div
                        style={{
                            background: '#fff',
                            position: 'relative',
                            height: '100%',
                            overflowY: 'auto',
                            flex: 1,
                            padding: '10px 10px 45px'
                        }}
                    >
                        <ProcessedRecords
                            disabled
                            key={`ProcessedRecords ${onSelectedReport._id}`}
                            actions={actions}
                            flowId={flowId}
                            currentPreviewReport={onSelectedReport}
                            currentAgent={currentAgent}
                            editable={currentAgent.permission.includes('reportRecordEdit')}
                        />
                    </div> : null
                }
                {
                    showformOrVideoOrPhoto === 'lossMessage' && onSelectedReport ? <div
                        style={{
                            position: 'relative',
                            height: '100%',
                            overflowY: 'auto',
                            flex: 1,
                            padding: '10px 10px 45px',
                            background: '#fff'
                        }}
                    >
                        <LossMessage
                            target="reportDetail"
                            flowId={flowId}
                            currentAgent={this.props.currentAgent}
                        />
                    </div> : null
                }
                {
                    showformOrVideoOrPhoto === 'ele' && onSelectedReport ? <div
                        style={{
                            position: 'relative',
                            height: '100%',
                            overflowY: 'auto',
                            flex: 1,
                            padding: '10px 10px 45px',
                            background: '#fff'
                        }}
                    >
                        <EleControlPane
                            target="reportDetail"
                            flowId={flowId}
                            currentAgent={this.props.currentAgent}
                            getReadStatus={this.getReadStatus}
                            dataSource={this.state.dataSource}
                            getListData={this.getListData}
                        />
                    </div> : null
                }
                {
                    showformOrVideoOrPhoto === 'risk-system' ? <div
                        style={{
                            position: 'relative',
                            height: '100%',
                            overflowY: 'auto',
                            flex: 1,
                            padding: '0 0 45px',
                            background: '#fff'
                        }}
                    ><RiskSystem flowId={flowId} disabled={true} /></div> : null
                }
                {
                    showformOrVideoOrPhoto === 'express-material' ? <div
                        style={{
                            position: 'relative',
                            height: '100%',
                            overflowY: 'auto',
                            flex: 1,
                            padding: '15px 15px 45px',
                            background: '#fff'
                        }}
                    ><MaterialExpress flowId={flowId} isReportAgent={isReportAgent} isAuditor={isExpressAuditor} /></div> : null
                }
                <div className="btn-bottom-fixed">
                    <div>
                        <Button
                            type="primary"
                            onClick={this.handleBack.bind(this)}
                            className="margin-right"
                        >
                            返回
                        </Button>
                        <Button
                            type="primary"
                            onClick={this.showRemarksModal}
                            className="margin-right"
                        >
                            备注
                        </Button>
                        {/* 撤案、拒赔，账号有重开权限，显示重开案件按钮 */}
                        {
                            onSelectedReport.state === 'finished' && ['withdraw', 'reject'].includes(onSelectedReport.subState) && agentPermissions.includes('reopenReport') ? (
                                <Popconfirm title="确定要重开案件？" visible={reopenVisible} onConfirm={this.handleReopen} onCancel={this.handleCancelReopen} okButtonProps={{ loading: reopenLoading }}>
                                    <Button type="primary" className="margin-right" danger onClick={() => this.setState({ reopenVisible: true })}>
                                        重开案件
                                    </Button>
                                </Popconfirm>
                            ) : null
                        }
                        {this.props.currentAgent.orgAccount &&
                            this.props.currentAgent.orgAccount.isAdjust &&
                            ['claiming', 'claimReturned'].includes(onSelectedReport.state) ? (
                            <Popover content={info} title="">
                                <Button type="primary" className="margin-right">
                                    医疗理算
                                </Button>
                            </Popover>
                        ) : null}
                    </div>
                    <div className="operation-btns">
                        {
                            (orgPermissions && orgPermissions.includes('recommendWithdraw')) && onSelectedReport?.flags?.recommendWithdraw ? <RecommendWithdraw flowId={flowId} status={onSelectedReport?.flags?.recommendWithdraw} nextTime={onSelectedReport?.nextRecommendWithdraw} onSuccess={this.getDetail} /> : null
                        }
                        {
                            onSelectedReport?.flags?.recommendChecked && isBounceByReport(onSelectedReport) && (orgPermissions && orgPermissions.includes('recommendChecked')) ? <RecommendCheckedBtn flowId={flowId} /> : null
                        }
                        
                        {/* v1.7.6修改 */}
                        <Dropdown overlayStyle={{ width: 95 }} overlay={<Menu>
                            {onSelectedReport.isLostContactCsr === 1 ? (
                                <Menu.Item
                                    disabled
                                    style={{
                                        border: 'none',
                                        color: '#F22727',
                                        background: '#fff',
                                        opacity: 0.5
                                    }}
                                >
                                    客户已失联
                                </Menu.Item>
                            ) : (
                                <Menu.Item
                                    disabled
                                    style={{ border: 'none', color: '#BBBBBB', background: '#fff' }}
                                >
                                    客户失联？
                                </Menu.Item>
                            )}

                            {onSelectedReport &&
                                onSelectedReport.majorCase &&
                                onSelectedReport.majorCase.type &&
                                onSelectedReport.majorCase.yes &&
                                this.state.majorCaseTypes.length !== 0 &&
                                onSelectedReport.majorCase.type !== 'NORMAL' ? (
                                <Menu.Item
                                    disabled
                                    style={{
                                        border: 'none',
                                        color: '#F22727',
                                        background: '#fff',
                                        opacity: 0.5
                                    }}
                                >
                                    {
                                        this.state.majorCaseTypes.find(
                                            (item) => item.value === onSelectedReport.majorCase.type
                                        ).label
                                    }
                                </Menu.Item>
                            ) : (
                                <Menu.Item
                                    disabled
                                    style={{ border: 'none', color: '#BBBBBB', background: '#fff' }}
                                >
                                    大案疑案
                                </Menu.Item>
                            )}

                            {this.state.complaintResult.records.length > 0 ? (
                                <Popover
                                    overlayStyle={{ width: 400 }}
                                    trigger="click"
                                    content={
                                        <div>
                                            <Timeline style={{ maxHeight: 500, overflowY: 'auto', paddingTop: 10 }}>
                                                {this.state.complaintResult.records.map((item) => (
                                                    <Timeline.Item>
                                                        <div>
                                                            {dayjs(item.time).format(
                                                                'YYYY.MM.DD HH:mm'
                                                            )}{' '}
                                                            {item.levelName} 操作：{item.agent}
                                                        </div>
                                                        <div>
                                                            投诉内容：{item.typesNames} {item.content}
                                                        </div>
                                                    </Timeline.Item>
                                                ))}
                                            </Timeline>
                                            {this.state.complaintResult.records.length > 0 && (
                                                <Button
                                                    onClick={this.showComplainModal}
                                                    size="small"
                                                    type="primary"
                                                >
                                                    追加投诉
                                                </Button>
                                            )}
                                        </div>
                                    }
                                    title=""
                                >
                                    <Menu.Item
                                        onClick={
                                            this.state.complaintResult.records.length > 0
                                                ? undefined
                                                : this.showComplainModal
                                        }
                                        style={{ border: 'none', color: '#F22727', background: '#fff' }}
                                    >
                                        {this.state.complaintResult.curLevelName ? (
                                            this.state.complaintResult.curLevelName
                                        ) : (
                                            <span style={{ color: '#606C86' }}>{'客户投诉'}</span>
                                        )}
                                    </Menu.Item>
                                </Popover>
                            ) : (
                                <Menu.Item
                                    onClick={
                                        this.state.complaintResult.records.length > 0
                                            ? undefined
                                            : this.showComplainModal
                                    }
                                    style={{ border: 'none', color: '#F22727', background: '#fff' }}
                                >
                                    {this.state.complaintResult.curLevelName ? (
                                        this.state.complaintResult.curLevelName
                                    ) : (
                                        <span style={{ color: '#606C86' }}>{'客户投诉'}</span>
                                    )}
                                </Menu.Item>
                            )}
                            {onSelectedReport.longTimeTrack === 'not' && (
                                <Menu.Item
                                    disabled
                                    style={{ border: 'none', color: '#BBBBBB', background: '#fff' }}
                                >
                                    长期跟踪
                                </Menu.Item>
                            )}

                            {onSelectedReport.longTimeTrack === 'yes' && (
                                <Menu.Item
                                    style={{
                                        border: 'none',
                                        color: '#F22727',
                                        background: '#fff',
                                        opacity: 0.5
                                    }}
                                >
                                    取消长期跟踪
                                </Menu.Item>

                            )}


                            {/* 是否诉讼 */}
                            {
                                !onSelectedReport?.relateComplaint &&
                                <Menu.Item
                                    style={{ color: '#606C86', cursor: 'not-allwoed' }}
                                    onClick={() => {
                                        Modal.confirm({
                                            title: '确定置为诉讼案件?',
                                            onOk: () => {
                                                setRelateComplaint({ flowId: flowId, relateComplaint: true }).then(res => {
                                                    message.success('操作成功')
                                                    this.getReport()
                                                })
                                            },
                                            onCancel() {
                                                console.log('Cancel');
                                            },
                                        });
                                    }}
                                >
                                    是否诉讼
                                </Menu.Item>
                            }
                            {

                                onSelectedReport?.relateComplaint &&
                                <Menu.Item
                                    style={{ color: '#F22727', cursor: 'not-allwoed' }}
                                    onClick={() => {
                                        Modal.confirm({
                                            title: '确定取消诉讼?',
                                            onOk: () => {
                                                setRelateComplaint({ flowId: flowId, relateComplaint: false }).then(res => {
                                                    message.success('操作成功')
                                                    this.getReport()
                                                })
                                            },
                                            onCancel() {
                                                console.log('Cancel');
                                            },
                                        });
                                    }}
                                >
                                    诉讼案件
                                </Menu.Item>
                            }


                        </Menu>}>
                            <Button
                                type="text"
                            >
                                更多操作
                            </Button>
                        </Dropdown>
                    </div>
                </div >

                {
                    this.state.isShowTaskListModal ? (
                        <TaskListModal
                            assigned={this.state.assigned}
                            flowId={flowId}
                            type={taskType}
                            actions={this.props.actions}
                            history={this.props.history}
                            hideTaskListModal={this.hideTaskListModal}
                            agentId={currentAgent._id}
                            currentAgentForTaskListModal={currentAgent}
                            handler={
                                currentAgent.agentRole &&
                                    (currentAgent.agentRole.level === '2' ||
                                        currentAgent.agentRole.level === '3')
                                    ? ''
                                    : currentAgent._id
                            }
                        />
                    ) : null
                }

                <Modal
                    title="确定为客户投诉案件?"
                    visible={this.state.visibleComplain}
                    onOk={this.handleOkComplain}
                    onCancel={this.handleCancelComplain}
                >
                    <p style={{ fontSize: 14 }}>
                        投诉等级<span style={{ color: 'red', fontSize: 14 }}>*</span>
                    </p>
                    <div style={{ height: 5 }}></div>
                    <Radio.Group
                        onChange={this.onChangeRadioComplain}
                        value={this.state.valueRadioComplain}
                    >
                        <Radio value='COMPL_BASIC' key="COMPL_BASIC">基础投诉</Radio>
                        <Radio value='COMPL_95500' key='COMPL_95500'>955投诉</Radio>
                        <Radio value='COMPL_COMPANY' key='COMPL_COMPANY'>保险公司投诉</Radio>
                        <Radio value='COMPL_BANK_COMM' key='COMPL_BANK_COMM'>保监投诉</Radio>
                    </Radio.Group>
                    <div style={{ height: 10 }}></div>

                    <p style={{ fontSize: 14 }}>
                        投诉内容
                        <span
                            style={{
                                color: 'red'
                            }}
                        >
                            *
                        </span>
                    </p>
                    <div style={{ height: 5 }}></div>
                    <Checkbox.Group
                        options={options}
                        value={this.state.valueCheckboxComplain}
                        onChange={this.onChangeCheckboxComplain}
                    />

                    <div style={{ height: 10 }}></div>
                    <Input.TextArea
                        maxLength={100}
                        value={this.state.textAreaValue}
                        onChange={this.onChangeTextAreaValue}
                        rows={4}
                        placeholder="请输入自定义内容"
                    />
                </Modal>
            </div >
        );
    }
}

let mapStateToProps = (state) => {
    return {
        customers: state.app.customers.current,
        reportReceipts: state.lossAss.reportReceipts.reportPageList,
        lossAssDashboard: state.lossAss.lossAssDashboard,
        onSelectedReport: state.lossAss.selectedReport.selectedReport,
        handelShowUpload: state.lossAss.reportReceipts.handelShowUpload,
        uploadImgArr: state.lossAss.reportReceipts.uploadImgArr,
        reportPreview: state.lossAss.reportPreview,
        customer: state.app.customers.current[0],
        currentAgent: state.app.currentAgent.userInfo,
        safetyMechanism: state.app.safetyMechanism.list,
        remark: state.reportDetail.remark
    };
};

let mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(
            Object.assign(
                {},
                report,
                lossAssDashboard,
                reportPreviewActions,
                agentActions,
                safetyMechanismAction
            ),
            dispatch
        )
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(WithRemark(ReportDetail)));
